export default {
    ADD_ITEM: function (state, item) {
        state.configurator.items.push(item);
    },
    INIT_DATA: function (state, data) {
        state.configurator = data.configurator;
        state.variantInfos = data.variantInfos;
        state.fillingMapping = data.fillingMapping;
        state.collectionName = data.collectionName;
        state.collectionId = data.collectionId;
        state.collectionType = data.collectionType;
        state.productSets = data.productSets;
        state.productTypes = data.productTypes;
        state.productTypeTexts = data.productTypeTexts;
        state.collectionFixed = data.collectionFixed;
        state.images = data.images;
        state.variantImages = data.variantImages;
        state.localeTag = data.localeTag;
    },
    UDPATE_CONFIGURATOR: function (state, data) {
        state.configurator = data;
        state.selectedSet =
            data.selectedProductSetId == null ? 0 : data.selectedProductSetId;
    },
    LOADING_CONTENT: function (state, data) {
        state.loadingContent = data;
    }
};
